import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useCachedLogo from "../common/useCachedLogo";

function EXHome() {
  const navigate = useNavigate();

  // ✅ logo is STRING, not array — fetched via shared cached hook
  const { logo } = useCachedLogo();
	const [loading, setLoading] = useState(!logo);
	const apiMode = 'normal';

  // ✅ Removed duplicate logo fetch — using cached logo

  // 2️⃣ Call iframe API ONLY after logo loaded
  useEffect(() => {
    if (!logo) { setLoading(true); return; }
    setLoading(false);

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const remote_id = localStorage.getItem("remote_id");

        const url = apiMode === 'transfer'
          ? `${process.env.REACT_APP_API_URL}/api/9wkt/join`
          : `${process.env.REACT_APP_API_URL}/api/iframe/play`;

        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({
            id: "eg_" + remote_id,
            token: token,
            providerSitePage: window.location.origin,
            origin: window.location.origin,
            siteLogo: `${process.env.REACT_APP_API_URL}/storage/${logo}`,
          }),
        });

        const dataly = await response.json();

        const iframeUrl = dataly?.data?.launch?.data?.launchUrl ?? dataly?.game_url;
        console.log(iframeUrl);

        if (!iframeUrl) {
          throw new Error("Invalid iframe launch response");
        }

       if (iframeUrl.match(/mcwbd/i) || dataly?.data?.fullRedir || iframeUrl.includes('#/9wkt')) {
  			  window.location.href = iframeUrl;
  			  return;
  		}

        navigate("/gamerun", { state: { iframeUrl, apiMode } });
      } catch (error) {
        console.error("Error fetching player login:", error);
      }
    };

    fetchData();
  }, [logo, navigate]);

  return null;
}

export default EXHome;
